import { GraphDto } from "@custom-types/graphs"
import { useGraphDocumentData } from "@features/builder/GraphDocumentProvider/hooks/useGraphDocumentData"
import { GraphDetails } from "@features/builder/types"
import RunGroupDialog from "@features/run/RunGroupDialog"
import RunGroupForm, { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { getUpdatedGraphDto } from "@utils/graph"

const FORM_ID = "build-page-run-group-form"

const BuilderRunGroupDialog = (props: {
  graph: GraphDto
  onSubmit: (data: RunGroupFormValues) => Promise<void>
  isSubmitting: boolean
  onClose: () => void
}) => {
  const { data } = useGraphDocumentData()

  if (!data) return <></>

  const graphDetails = JSON.parse(data) as GraphDetails
  const updatedGraph = getUpdatedGraphDto(graphDetails, props.graph)

  return (
    <RunGroupDialog open isSubmitting={props.isSubmitting} onClose={props.onClose} formId={FORM_ID}>
      <RunGroupForm id={FORM_ID} graph={updatedGraph} onSubmit={props.onSubmit}>
        <RunGroupForm.Name />
        <RunGroupForm.NumberOfSamplings />
        <RunGroupForm.Seed />
        <RunGroupForm.ContractKey />
        <RunGroupForm.StartDate />
        <RunGroupForm.EndDate />
        <RunGroupForm.Scenario />
        <RunGroupForm.Description />
        <RunGroupForm.LinkedGraphMode />
        <RunGroupForm.Validate />
      </RunGroupForm>
    </RunGroupDialog>
  )
}

export default BuilderRunGroupDialog
